import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const StyleSummaryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.m};
`;

export const SummaryCardTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  display: flex;
`;

export const SummaryDataContainer = styled.div`
  display: flex;
  padding: 0 ${({ theme }) => theme.spacing.xs}
    ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.xs};
  align-items: center;

  & .donut-circle-bg {
    stroke-width: 5;
    stroke: ${({ theme }) => theme.colorsInObjects.gray[600]};
  }

  & .donut-circle-value {
    stroke-width: 5;
  }
`;

export const SummaryInfosContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const SummaryInfosTextContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const SummaryInfosTitlesContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spacing.l};
`;
